<template>
  <div class="home">
    <Hero />
    <Expierence />
    <BestIn />
    <OverviewBanner />
    <AboutExp />
    <FAQ />
    <!-- <Testimonials /> -->
  </div>
</template>

<script>

import Hero from '@/components/home/Hero.vue'
import Expierence from "@/components/home/Expierence.vue"
import BestIn from "@/components/home/BestIn.vue"
import OverviewBanner from "@/components/home/OverviewBanner.vue"
import AboutExp from "@/components/home/AboutExp.vue"
import FAQ from "@/components/home/FAQ.vue"
// import Testimonials from "@/components/home/Testimonials.vue"

export default {
  name: 'HomeView',
  components: {
    Hero,
    Expierence,
    BestIn,
    OverviewBanner,
    AboutExp,
    FAQ
    // Testimonials,
  }
}
</script>
<style>
/* .home {
  background-image: url("@/assets/top_right_bg.png");
  background-position: left;
  background-size: cover;
  background-repeat: no-repeat;
} */
</style>
